module.exports = __webpack_public_path__ + "img/wifi.1a41c411.svg";